export enum QuizStepEnum {
  CADASTRO = 0,
  PERGUNTAS = 1,
  RESULTADO = 2,
}

const descricao = new Map<QuizStepEnum, string>([
  [QuizStepEnum.CADASTRO, 'CADASTRO'],
  [QuizStepEnum.PERGUNTAS, 'PERGUNTAS'],
  [QuizStepEnum.RESULTADO, 'RESULTADO'],
]);

export class QuizEstiloDeVidaEnumDescription {
  static getDescricao(valor: QuizStepEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): { valor: QuizStepEnum; descricao: string }[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({
      valor,
      descricao,
    }));
  }
}
